// IRS Standard Mileage Rate lookup, keyed by tax year.
// The IRS publishes new rates each December for the following year.
// Update this table when the IRS announces new rates:
//   https://www.irs.gov/tax-professionals/standard-mileage-rates
//
// The app auto-selects the rate for the current year at runtime.
// Users can still override with a custom rate in Settings — that takes precedence.

export const IRS_MILEAGE_RATES = {
  // year: { business, medical, charity }
  2022: { business: 0.585, medical: 0.18, charity: 0.14 }, // Jan-Jun 2022 (mid-year change: 0.625 Jul-Dec)
  2023: { business: 0.655, medical: 0.22, charity: 0.14 },
  2024: { business: 0.67,  medical: 0.21, charity: 0.14 },
  2025: { business: 0.70,  medical: 0.21, charity: 0.14 },
  // 2026 not yet published as of Feb 2026 — falls back to most-recent known year.
};

const LATEST_KNOWN_YEAR = Math.max(...Object.keys(IRS_MILEAGE_RATES).map(Number));

/**
 * Returns the IRS business mileage rate ($/mile) for the given year.
 * Falls back to the most recent known year if the target year isn't in the table yet.
 */
export const getIrsMileageRate = (year = new Date().getFullYear(), category = 'business') => {
  const rates = IRS_MILEAGE_RATES[year] || IRS_MILEAGE_RATES[LATEST_KNOWN_YEAR];
  return rates[category] ?? rates.business;
};

/**
 * Returns the year whose rate is actually being used (either the requested
 * year or the fallback). Useful for showing "Using IRS 2025 rate (2026 not
 * yet published)" hints.
 */
export const getIrsMileageRateYear = (year = new Date().getFullYear()) => {
  return IRS_MILEAGE_RATES[year] ? year : LATEST_KNOWN_YEAR;
};

/** Returns true when the current year's rate has not been published yet. */
export const isIrsRateProvisional = (year = new Date().getFullYear()) =>
  !IRS_MILEAGE_RATES[year];
